module.exports = __webpack_public_path__ + "static/media/Wobbuffet_gaussian2.e3a442a3.png";